import { h as __h } from "preact";
import { signal } from "@preact/signals";
/** @import { Signal } from "@preact/signals"; */
import { Component, h } from "preact";
import { orgMemberResponse } from "~/backend/validate.js";
import { ApiError, authedApiRequest, paginatedResponse, query } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
/** @import { Placement } from "~/util/float.js"; */
import { popover } from "~/util/popover.js";
import Query from "~/util/query.js";
import Button from "~/component/Button.js";
import Combobox from "~/admin/component/Combobox.js";
/** @import { Option } from "~/admin/component/Combobox.js"; */
import UserStack from "~/admin/component/UserStack.js";
import adminStyle from "~/admin/lib/style.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./addMembers.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./addMembers.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @param {{
 * 	anchor: HTMLButtonElement;
 * 	orgId: string;
 * 	groupId: string;
 * 	placement: Placement;
 * }} props
 */
export const addMembers = async ({
  anchor,
  orgId,
  groupId,
  placement
}) => {
  const user_ids = await popover({
    anchor,
    placement,
    content: (/** @type {(result?: string[]) => void} */resolve) => h(PopoverChildren, {
      resolve,
      orgId
    })
  });
  if (!user_ids?.length) return;
  try {
    await authedApiRequest("POST", `/v2/orgs/${orgId}/groups/${groupId}/members`, {
      json: {
        user_ids
      }
    });
    Query.invalidate([`/v2/orgs/${orgId}/groups`], [`/v2/orgs/${orgId}/groups/${groupId}`], [`/ui/admin/orgs/${orgId}/members`], ...user_ids.map(id => [`/ui/admin/orgs/${orgId}/members/${id}`]));
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};

/**
 * @extends {Component<PopoverChildrenProps>}
 *
 * @typedef {object} PopoverChildrenProps
 * @property {string} orgId
 * @property {(result?: string[]) => void} resolve
 */
class PopoverChildren extends Component {
  query = signal("");
  /** @type {Signal<Map<string, Option>>} */
  selected = signal(new Map());
  members = query(() => ({
    key: [`/v2/orgs/${this.props.orgId}/members`, {
      limit: 5,
      q: this.query.value
    }],
    keepPreviousData: true
  }), {
    schema: paginatedResponse(orgMemberResponse)
  });
  render() {
    return __h("div", {
      "class": css.popover
    }, h(Combobox, {
      query: this.query,
      debounce: 200,
      loading: this.members.loading,
      multiSelected: this.selected,
      options: this.members.data?.data.map(member => ({
        id: member.id,
        label: member.name,
        render: () => __h(UserStack, {
          name: member.name,
          email: member.email
        })
      }))
    }), __h("div", {
      "class": adminStyle.actions
    }, __h(Button, {
      level: "primary",
      disabled: this.selected.value.size === 0,
      onClick: () => this.props.resolve([...this.selected.value.keys()])
    }, "Add members"), __h(Button, {
      onClick: () => this.props.resolve()
    }, "Cancel")));
  }
}